export default {
    name: 'v5-icon-right',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M887.904 298.208c-12.864-12.064-33.152-11.488-45.216 1.408L415.936 753.984l-233.12-229.696c-12.608-12.416-32.864-12.288-45.28.32-12.416 12.576-12.256 32.864.352 45.248l256.48 252.672c.096.096.224.128.32.224s.128.224.224.32c2.016 1.92 4.448 3.008 6.784 4.288 1.152.672 2.144 1.664 3.36 2.144 3.776 1.472 7.776 2.24 11.744 2.24 4.192 0 8.384-.832 12.288-2.496 1.312-.544 2.336-1.664 3.552-2.368 2.4-1.408 4.896-2.592 6.944-4.672.096-.096.128-.256.224-.352.064-.096.192-.128.288-.224L889.28 343.424c12.16-12.832 11.488-33.088-1.376-45.216z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
